export default {"src":"/_next/static/media/MO.f4efa53e.svg","height":18,"width":18};